import { Link } from "@mui/material";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";
import { TbShirtSport } from "react-icons/tb";

export const purchaseGiftCardLanguages = {
  navMenueLinkText: "Purchase Deposit",
  pageTitle: "Winnipeg Jets Deposit",
  mainCardTitle: "Purchase Deposit",
  amountTitle: "Deposit Amount",
  checkoutCardTitle: "Purchase Deposit",
  checkoutItemTitle: "Deposit Amount",
};

export const purchaseSeatsLanguages = {
  purchaseSeatTabTitle: "Create Flex Plan",
  similarSeatModalBody: (seatTitle: string) => (
    <>
      If you&apos;d like to apply your seat selection to similar seats for all
      games in your Flex Plan, click <b>Continue to checkout</b>. You can
      review/change your seats prior to finalizing your Flex Plan.
      <br />
      <br />
      If you&apos;d prefer to choose your seats game by game, click{" "}
      <b>Select different seats</b>.
    </>
  ),
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games ",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <TbShirtSport />,
    title: "Login to Account Manager",
    description:
      "Click Continue and connect your Sacramento Kings account using our secure Ticketmaster login.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description: (
      <>
        Tickets will be available in your&nbsp;
        <Link
          href={"https://am.ticketmaster.com/sackings/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          Sacramento Kings account
        </Link>{" "}
        within 24 hours of redemption. Reach out to Live Fan Support for any
        questions.
      </>
    ),
  },
];

export const faqs = [
  {
    title: "How does the Sacramento Kings Flex Plans program work?",
    description:
      "The Sacramento Kings Flex Plan allows fans to select any seat to any game. Simply log into your Sacramento Kings Account manager and select games.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory. ",
  },
  {
    title: "Where are event tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your Sacramento Kings
        Account Manager at&nbsp;
        <Link
          href={"https://am.ticketmaster.com/sackings/"}
          target={"_blank"}
          sx={{
            color: "primary.main",
            textDecoration: "none",
            fontWeight: 500,
          }}
        >
          https://am.ticketmaster.com/sackings/
        </Link>
        .
      </>
    ),
  },
  {
    title: "Are any games excluded?",
    description: (
      <>
        Any upcoming home game can be included in your Flex Plan.{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://www.nba.com/kings/single-game-tickets"
        >
          Click here
        </Link>{" "}
        for more information about upcoming games.
      </>
    ),
  },
  {
    title:
      "What happens if I can no longer attend a game that I included in my Flex Plan?",
    description: (
      <>
        Tickets are non-refundable. You can manage your game tickets in your{" "}
        <Link
          target="_blank"
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="https://am.ticketmaster.com/sackings/#/"
        >
          ClickTix account
        </Link>
        , including forwarding your tickets to friends or family.
      </>
    ),
  },
  {
    title:
      "Who do I contact if I have questions or need help with my Flex Plan?",
    description: (
      <>
        Please call{" "}
        <Link
          sx={{
            fontWeight: 500,
            color: "primary.main",
            textDecoration: "none",
          }}
          href="tel:888-91-KINGS"
        >
          888-91-KINGS
        </Link>{" "}
        for assistance with your Flex Plan.
      </>
    ),
  },
];

export function CheckoutTerms() {
  return (
    <>
      By purchasing you agree to receive SMS alerts regarding ticket delivery
      and agree to the{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"

        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/616882d2b691e09f75348396_Terms%20%26%20Conditions.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Terms & Conditions
      </Link>{" "}
      and{" "}
      <Link
        // fontWeight={"bold"}
        // textDecor="underline"
        href={
          "https://uploads-ssl.webflow.com/5ed7df6fe67e862e0a62f9f2/63c05d80816dac05b5b34ac7_seasonshare%20CCPA%20Privacy%20Policy%20Agreement.pdf"
        }
        target={"_blank"}
        sx={{
          color: "primary.main",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Privacy Policy
      </Link>
      .
    </>
  );
}
